module.exports = __webpack_public_path__ + "img/cut-and-fill.50552619.svg";